import { ChartConfig } from "./chart.model";

export interface UsersRequest {
    registrados: {
        numero: number
    };
    anonimos:{
        numero: number
    };
}

export interface UserI {
    date: number;
    name: string;
    value: number;
}

export const USER_CHART_CONFIG: ChartConfig = {
    type: 'line',
    // yAxis: {},
    xAxis: {
        type: 'datetime',
        dateTimeFormat: {
            day: '%d',
            month: '%b %Y'
        }
    }
};